import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SlWapiService } from '../model/api-services/sl-wapi.service';
import * as DetectBrowser from 'detect-browser';
import { DMIGuard } from './dmi.guard';


@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {

	constructor(
		private router: Router,
		private wapi: SlWapiService
	) { }

	canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): boolean {
		const browser = DetectBrowser.detect();

		switch (browser && browser.name) {
			case 'ie':

			//return false;
		}
    if((document.location.href.indexOf('dmi.simplelayers.com') > 0) || (document.location.href.indexOf('/dmi-pages/') > 0)) {
      const dmiGuard = new DMIGuard(this.router,this.wapi);
      return dmiGuard.canActivate(route,routerState);
    }

		if (this.wapi.HasAuthCookie() && this.wapi.HasSession()) {
			return true;
		}
		if (this.wapi.HasAuthCookie() && !this.wapi.HasSession()) {
			this.wapi.AuthenticateToken().then(() => {
				this.router.navigate([decodeURI(routerState.url)]);
        return true;
			}).catch(() => {
				this.wapi.SetAuthTo(decodeURI(routerState.url));
				this.router.navigate(['/login']);
			});
			return true;
		}

		this.wapi.SetAuthTo(decodeURI(routerState.url));
		// not logged in so redirect to login page with the return url
		this.router.navigate(['/login']);
		return false;
	}

}
